import { localisedValue } from "utils"

const citiesTransformer = response => {
    const cities = response?.cities?.map(e => ({
        ...e,
        key: e?.id,
        label: localisedValue({ object: e, key: "name" }),
        value: e?.id?.toString(),
      }))
      return cities
  }
  
  export default citiesTransformer